import React from 'react'
import { func, string, arrayOf } from 'prop-types'
import { Button, Card, Grid, Divider } from '@cobalt/cobalt-react-components'
import MechanismOption from './MechanismOption'
import {
  MFA_SETTINGS_WEB_AUTHN_DESCRIPTION,
  MFA_SETTINGS_TOTP_DESCRIPTION,
  MFA_SETTINGS_SETUP,
  MFA_SETTINGS_REVOKE
} from '../../constants/ui.labels'
import { TOTP, WEB_AUTHN, Properties } from '../../constants/mfa'
import {
  SETUP_TOTP_MECHANISM,
  SETUP_WEB_AUTHN_MECHANISM
} from '../../constants/links'
import { SETTINGS_CARD_BACKGROUND_COLOR } from '../../constants/colors'

const AvailableMFA = [
  {
    type: WEB_AUTHN,
    description: MFA_SETTINGS_WEB_AUTHN_DESCRIPTION,
    redirectTo: SETUP_WEB_AUTHN_MECHANISM,
    ...Properties[WEB_AUTHN]
  },
  {
    type: TOTP,
    description: MFA_SETTINGS_TOTP_DESCRIPTION,
    redirectTo: SETUP_TOTP_MECHANISM,
    ...Properties[TOTP]
  }
]

const renderDivider = isLastElement =>
  !isLastElement ? <Divider noMargin /> : <React.Fragment />

const renderActionButton = (isActive, onRevoke, onSetup) =>
  isActive ? (
    <Button danger inverted small onClick={onRevoke} fullWidth>
      {MFA_SETTINGS_REVOKE}
    </Button>
  ) : (
    <Button primary inverted small onClick={onSetup} fullWidth>
      {MFA_SETTINGS_SETUP}
    </Button>
  )

const MechanismsList = ({ enabledMFAMechanisms, onRevoke, onSetup }) => (
  <Card backgroundColor={SETTINGS_CARD_BACKGROUND_COLOR}>
    <Card.Content fullWidth noPadding>
      {AvailableMFA.map(({ redirectTo, type, color, ...settings }, index) => {
        const isActive = enabledMFAMechanisms.includes(type)
        return (
          <React.Fragment key={index}>
            <div style={{ margin: '1rem 0' }}>
              <Grid>
                <Grid.Group>
                  <Grid.Column>
                    <MechanismOption
                      activeColor={color}
                      {...settings}
                      isActive={isActive}
                    />
                  </Grid.Column>
                  <Grid.Column small="hide" all="min">
                    {renderActionButton(
                      isActive,
                      () => onRevoke(type),
                      () => onSetup(redirectTo)
                    )}
                  </Grid.Column>
                </Grid.Group>
                <Grid.Group>
                  <Grid.Column large="hide" medium="hide">
                    <div style={{ marginTop: '1rem', width: '100%' }}>
                      {renderActionButton(
                        isActive,
                        () => onRevoke(type),
                        () => onSetup(redirectTo)
                      )}
                    </div>
                  </Grid.Column>
                </Grid.Group>
              </Grid>
            </div>
            {renderDivider(index === AvailableMFA.length - 1)}
          </React.Fragment>
        )
      })}
    </Card.Content>
  </Card>
)

MechanismsList.propTypes = {
  enabledMFAMechanisms: arrayOf(string).isRequired,
  onRevoke: func.isRequired,
  onSetup: func.isRequired
}

export default MechanismsList
